import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const RECENT_EXERCISES_TAG = 'RecentExercise';
export const SAVED_EXERCISES_TAG = 'SavedExercise';

export const exercisesApi = createApi({
  reducerPath: 'exercisesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [RECENT_EXERCISES_TAG, SAVED_EXERCISES_TAG],
  endpoints: (builder) => ({
    getRecentExercises: builder.query({
      query: ({ userWeight } = {}) => ({
        url: '/recent-exercises',
        method: 'GET',
        params: userWeight ? { userWeight } : undefined,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((entry) => ({ type: RECENT_EXERCISES_TAG, id: entry._id })),
              { type: RECENT_EXERCISES_TAG, id: 'LIST' },
            ]
          : [{ type: RECENT_EXERCISES_TAG, id: 'LIST' }],
    }),

    logRecentExercise: builder.mutation({
      query: ({ id, userWeight }) => ({
        url: `/recent-exercises/${id}/log`,
        method: 'POST',
        body: { userWeight },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: RECENT_EXERCISES_TAG, id },
        { type: RECENT_EXERCISES_TAG, id: 'LIST' },
      ],
    }),

    deleteRecentExercise: builder.mutation({
      query: (id) => ({
        url: `/recent-exercises/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: RECENT_EXERCISES_TAG, id },
        { type: RECENT_EXERCISES_TAG, id: 'LIST' },
      ],
    }),

    getSavedExercises: builder.query({
      query: ({ userWeight } = {}) => ({
        url: '/saved-exercises',
        method: 'GET',
        params: userWeight ? { userWeight } : undefined,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((entry) => ({ type: SAVED_EXERCISES_TAG, id: entry._id })),
              { type: SAVED_EXERCISES_TAG, id: 'LIST' },
            ]
          : [{ type: SAVED_EXERCISES_TAG, id: 'LIST' }],
    }),

    promoteRecentToSaved: builder.mutation({
      query: ({ recentId, name }) => ({
        url: '/saved-exercises/from-recent',
        method: 'POST',
        body: { recentId, name },
      }),
      invalidatesTags: [
        { type: SAVED_EXERCISES_TAG, id: 'LIST' },
        { type: RECENT_EXERCISES_TAG, id: 'LIST' },
      ],
    }),

    updateSavedExercise: builder.mutation({
      query: ({ id, name }) => ({
        url: `/saved-exercises/${id}`,
        method: 'PATCH',
        body: { name },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: SAVED_EXERCISES_TAG, id },
        { type: SAVED_EXERCISES_TAG, id: 'LIST' },
      ],
    }),

    logSavedExercise: builder.mutation({
      query: ({ id, userWeight }) => ({
        url: `/saved-exercises/${id}/log`,
        method: 'POST',
        body: { userWeight },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: SAVED_EXERCISES_TAG, id },
        { type: SAVED_EXERCISES_TAG, id: 'LIST' },
      ],
    }),

    deleteSavedExercise: builder.mutation({
      query: (id) => ({
        url: `/saved-exercises/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: SAVED_EXERCISES_TAG, id },
        { type: SAVED_EXERCISES_TAG, id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetRecentExercisesQuery,
  useLogRecentExerciseMutation,
  useDeleteRecentExerciseMutation,
  useGetSavedExercisesQuery,
  usePromoteRecentToSavedMutation,
  useUpdateSavedExerciseMutation,
  useLogSavedExerciseMutation,
  useDeleteSavedExerciseMutation,
} = exercisesApi;
